import { connect } from 'react-redux';
import { getIsDuperbrowseActive, getCurrentItem, getIsLoading, getLastViewedItem, } from '../redux/selectors';
import { exitDuperbrowse } from '../redux/actionCreators';
var mapStateToProps = function (state) { return ({
    isDuperbrowseActive: getIsDuperbrowseActive(state),
    currentItem: getCurrentItem(state),
    isLoading: getIsLoading(state),
    justClosedAStream: !!getLastViewedItem(state),
}); };
var mapDispatchToProps = {
    exitDuperbrowse: exitDuperbrowse,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DuperbrowsePageWrapper.container.js.map